var map = {
	"./Cave/1/Cave drakin.json": 83500,
	"./Cave/1/Crystalker.json": 28861,
	"./Cave/1/Dragon golem.json": 26168,
	"./Cave/1/Fire bearer.json": 32299,
	"./Cave/1/Frost drake.json": 58107,
	"./Cave/1/Frost whelp.json": 67747,
	"./Cave/1/Phyllosaurus.json": 92153,
	"./Cave/1/Red dragon.json": 27346,
	"./Cave/1/Scorpiron.json": 9654,
	"./Cave/1/Sluggish mass.json": 16091,
	"./Cave/1/Whelp golem.json": 45589,
	"./Cave/1/Wyvern.json": 86570,
	"./Cave/2/Armored stinger.json": 46998,
	"./Cave/2/Darkhound.json": 69393,
	"./Cave/2/Dawn.json": 55792,
	"./Cave/2/Duskwing.json": 56644,
	"./Cave/2/Ebony drake.json": 84133,
	"./Cave/2/Fjorra.json": 72034,
	"./Cave/2/Golem matriarch.json": 94656,
	"./Cave/2/Huntolithe.json": 37829,
	"./Cave/2/Litholine.json": 97274,
	"./Cave/2/Slugborn sister.json": 13006,
	"./Event/Aiden.json": 5560,
	"./Event/Ambrosa.json": 11132,
	"./Event/Amy.json": 59863,
	"./Event/Cinder.json": 29027,
	"./Event/Crimson witch.json": 46948,
	"./Event/Elder tree.json": 93417,
	"./Event/Eleni.json": 10237,
	"./Event/Imp.json": 33562,
	"./Event/Jenny.json": 57586,
	"./Event/Lena.json": 65676,
	"./Event/Lulu.json": 98673,
	"./Event/Lumberjack.json": 62951,
	"./Event/Manager.json": 76205,
	"./Event/Millie.json": 36910,
	"./Event/Orc general.json": 69156,
	"./Event/Petra.json": 26593,
	"./Event/Vesper.json": 70790,
	"./Event/Vivi.json": 54131,
	"./Forest/1/Barbarosa.json": 46098,
	"./Forest/1/Leafadon.json": 17485,
	"./Forest/1/Mycoroos.json": 46351,
	"./Forest/1/Nibkin.json": 98688,
	"./Forest/1/Rollinghog.json": 58334,
	"./Forest/1/Shrubtail.json": 20785,
	"./Forest/1/Skeleton.json": 10847,
	"./Forest/1/Witch doctor.json": 74282,
	"./Forest/2/Arachnea.json": 44814,
	"./Forest/2/Ashmane.json": 84090,
	"./Forest/2/Barbarina.json": 70782,
	"./Forest/2/Duskling.json": 16561,
	"./Forest/2/Mycelladon.json": 38224,
	"./Forest/2/Rollino.json": 31793,
	"./Forest/2/Skeleton warrior.json": 29917,
	"./Forest/2/Sprigtail.json": 92300,
	"./Ruins/1/Angry kobold.json": 79149,
	"./Ruins/1/Atyr.json": 20972,
	"./Ruins/1/Big blue slime.json": 45928,
	"./Ruins/1/Big green slime.json": 38113,
	"./Ruins/1/Blue slime.json": 83111,
	"./Ruins/1/Chillbat.json": 25990,
	"./Ruins/1/Chillquill.json": 48417,
	"./Ruins/1/Eyeless beast.json": 75419,
	"./Ruins/1/Goblin.json": 55290,
	"./Ruins/1/Green slime.json": 51927,
	"./Ruins/1/Knight kobold.json": 931,
	"./Ruins/1/Mage kobold.json": 14657,
	"./Ruins/1/Minos.json": 84828,
	"./Ruins/1/Scorchie.json": 39521,
	"./Ruins/1/Sorcerer kobold.json": 40035,
	"./Ruins/2/Angry urkobold.json": 78633,
	"./Ruins/2/Chillquilla.json": 79737,
	"./Ruins/2/Eyeless mane.json": 16200,
	"./Ruins/2/Goblin knight.json": 16522,
	"./Ruins/2/Knight urkobold.json": 26733,
	"./Ruins/2/Lamilys.json": 69904,
	"./Ruins/2/Mage urkobold.json": 52960,
	"./Ruins/2/Minosa.json": 22301,
	"./Ruins/2/Scorcher.json": 40477,
	"./Ruins/2/Slime doll.json": 65650,
	"./Ruins/2/Slime girl.json": 17183,
	"./Ruins/2/Sorcerer urkobold.json": 29241,
	"./Snow/1/Angry bear.json": 21289,
	"./Snow/1/Apprentice shaman.json": 98191,
	"./Snow/1/Black bear.json": 75258,
	"./Snow/1/Bonebreaker bandit.json": 19526,
	"./Snow/1/Dreadclaw.json": 28831,
	"./Snow/1/Golem.json": 51185,
	"./Snow/1/Grimhorn.json": 77505,
	"./Snow/1/Shade.json": 65512,
	"./Snow/1/Shaman bandit.json": 92559,
	"./Snow/1/Skinshredder bandit.json": 86216,
	"./Snow/1/Snow wolf.json": 62913,
	"./Snow/2/Bonebreaker raider.json": 68859,
	"./Snow/2/Dreadqueen.json": 28704,
	"./Snow/2/Gogolem.json": 55852,
	"./Snow/2/Great wolf.json": 98338,
	"./Snow/2/Mystical wolf.json": 38826,
	"./Snow/2/Skinshredder raider.json": 50752,
	"./Snow/2/Wailing shade.json": 21035,
	"./Snow/2/Wanderer.json": 90626,
	"./Snow/2/Werebear.json": 29826,
	"./Snow/2/Yuki-Onna.json": 78969,
	"./Unused/Big snake.json": 74617,
	"./Unused/Blast frog.json": 92064,
	"./Unused/Cryomaniac.json": 84130,
	"./Unused/Emberback.json": 95593,
	"./Unused/Fire slime.json": 60465,
	"./Unused/Frostspine.json": 56092,
	"./Unused/Ice frog.json": 56915,
	"./Unused/Maneater.json": 68738,
	"./Unused/Ratbat.json": 50967,
	"./Unused/Salamaniac.json": 23736,
	"./Unused/Shadefang.json": 90892,
	"./Unused/Stumpmaiden.json": 5227,
	"./Unused/Summoner enemy.json": 41263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52473;